import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useParams  } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import InputText from '../../elements/InputText';
// import InputTextArea from '../../elements/InputTextArea';
import RenderErrors from '../../elements/RenderErrors';
import ContactListModal from '../../modals/ContactListModal';
import AddressBookModal from '../../modals/AddressBookModal';
import ProductFinderModal from '../../modals/ProductFinderModal';
import PaymentsListModal from '../../modals/PaymentsListModal';
import initTreeView from '../../../services/initTreeView';
// import ButtonGroup from 'react-bootstrap/ButtonGroup';
// import Button from 'react-bootstrap/Button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputMask } from 'primereact/inputmask';

import { getApiData, getServiceHubEnums, postApiData } from '../../../services/apiService';
import BrandFormModal from '../../modals/BrandFormModal';
import InvoiceListModal from '../../modals/InvoiceListModal';
import { serviceRequestData } from '../../../services/serviceHubStore';
import ProductUnitFormModal from './ProductUnitFormModal';
import ProductUnitListModal from './ProductUnitListModal';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { MultiSelect } from 'primereact/multiselect';

export default function ServiceRequestSchedule (){
    const { service_request_id } = useParams();
    const [loading, setLoading] = useState(1);
    const navigate = useNavigate();
    const [errors, setErrors] = useState([]);
    const [page_title, setPageTitle] = useState('Add Service Schedule');
    const [form_data, setFormData] = useState(serviceRequestData);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [enums, setEnums] = useState(store.order_enums);
    const [sub_service_types, setSubTypes] = useState(store.order_enums);
    const [product_unit_list_modal, setProductUnitListModal] = useState(0);
    const [product_unit_form_modal, setProductUnitFormModal] = useState(0);
    const [customer_modal, setContactModal] = useState(0);
    const [address_modal, setAddressModal] = useState(0);
    const [address_type, setAddressType] = useState('');
    const [same_address, setSameAddress] = useState(0);
    const [payments_modal, setPaymentsModal] = useState(false);
    const [button_items, setButtonItems] = useState([]);
    const [show_brand_modal, setShowBrandModal] = useState(0);
    const dropdownRef = useRef(null);
    const [product_unit_id, setProductUnitID] = useState(0);
    const [selectedTechnicians, setSelectedTechnicians] = useState([]);
    const [employee_list, setEmployeeList] = useState([]);
    
   
    useEffect(() => {
        initTreeView()

        // if(service_request_id){
        //     fetchData(service_request_id)
        //     fetchEnums(service_request_id)
        // }
        // else{
        //     setButtonItems([{
        //         label: 'Save and Confirm',
        //         icon: 'pi pi-refresh',
        //         command: (e) => {
        //             submit(e.originalEvent, 2)
        //         }
        //     }])
        // }
        fetchEnums(service_request_id)
    }, []);
   
    useEffect(() => {
    }, [form_data]);
   
    useEffect(() => {
        if(enums?.service_types){
            const sub_types = helpers.filterObject(enums.service_types, form_data.service_type_id)

            setSubTypes(sub_types?.sub_service_types)
        }
    }, [form_data.service_type_id]);
    
        useEffect(() => {
            if(form_data.status == 1){
                setButtonItems([{
                    label: 'Save and Confirm',
                    icon: 'pi pi-refresh',
                    command: (e) => {
                        submit(e.originalEvent, 2)
                    }
                }])
            }
            else{
                setButtonItems([{
                    label: 'Draft',
                    icon: 'pi pi-refresh',
                    command: (e) => {
                        submit(e.originalEvent, 1)
                    }
                }])
            }
        }, [form_data, record_items]);
    
    useEffect(() => {
        displayTableItems()
    }, [
        record_items,
    ]);

    
    useEffect(() => {
        if(employee_list){
            fetchData(service_request_id)
        }
    }, [
        employee_list,
    ]);

    function displayTableItems(){
        let items = []
        
        if (record_items?.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                return(
                    <tr>
                        <td>{data.qr_code}</td>
                        <td>{data.brand}</td>
                        <td>{data.serial_no}</td>
                        <td>{data.invoice_no ? data.invoice_no : '---'}</td>
                        <td>{data.unit_location ? data.unit_location : '---'}</td>
                        <td>
                            <InputTextarea
                                name="complaint" 
                                value={data.complaint}  
                                className="w-100 mt-2 p-1"
                                maxLength={1000}
                                onChange={(e) => inputItemChange(e, key)}
                                placeholder="Describe unit problem"
                            />
                        </td>
                        <td width={100} style={{paddingRight: '.75rem'}}>
                            <ButtonGroup aria-label="Basic example" size="sm">
                                <Button variant="info" onClick={() => updateItem(data)}><i className="fas fa-pencil-alt"></i></Button>
                                <Button variant="danger" onClick={(e) => removeItem(key)}><i className="fas fa-times"></i></Button>
                            </ButtonGroup>
                        </td>
                    </tr>
                )
            })
        }

        setTableItems(items)
    }
    
    function inputItemChange(e, key) {
        let { value, name } = e.target;
        let items = [...record_items]
        let target = {...items[key]}

        if(name === 'quantity'){
            const available_stock = target['available_stock']

            if(target.tax_rate){
                
                const tax_amount = (parseFloat(target.tax_rate) / 100) * (parseInt(value) * parseFloat(target.amount))

                target.tax_amount = tax_amount
            }

            if(parseInt(value) > parseInt(available_stock)){
                return;
            }
        }
        else if(name === 'tax_rate'){
            name = 'tax_rate_id'
            const tax = helpers.filterObject(enums.tax_rates, value) ?? [];
            
            if ( tax.hasOwnProperty('id') ) {
                target.tax_name = tax.tax_name
                target.tax_rate = tax.tax_rate

                const tax_amount = (parseFloat(tax.tax_rate) / 100) * (parseFloat(target.amount) * parseFloat(target.quantity))

                if(!isNaN(tax_amount)){
                    target.tax_amount = tax_amount;
                }
            }
            else{
                target.tax_name = ''
                target.tax_rate = ''
                target.tax_amount = 0;
            }
        }
        else if(name === 'amount'){
            if(target.tax_rate){
                //const tax_amount = (parseFloat(target.tax_rate) / 100) * parseFloat(value)
                const tax_amount = (parseFloat(target.tax_rate) / 100) * (parseFloat(value) * parseFloat(target.quantity))

                target.tax_amount = tax_amount
            }
        }

        target[name] = value
        items[key] = target

        setRecordItems(items)
    }

    function updateItem(e){
        setProductUnitID(e.id)
        setProductUnitFormModal(1)
    }

    function removeItem(key){
        let items = [...record_items]
        items.splice(key, 1); 

        setRecordItems(items)
    }


    const fetchEnums = async (id) => {
        setLoading(true)
        let endpoint = helpers.createUrl(`V1/hrms/employees`)
        const res = await getApiData(endpoint, false)

        if(res){
            setEmployeeList(res)
             setLoading(0)
        }
    }

    async function fetchData(id){
        setLoading(1)
        if(!id){
            return
        }

        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/${id}`)
        const res = await getApiData(endpoint, false)

        if(res){
            setLoading(0)
            res.schedule_date = res.schedule_date ? new Date(res.schedule_date) : ''
            setFormData(res)
            setRecordItems(res.items)
            setSelectedTechnicians(res.members)

            if(!res.schedule_date){
                setPageTitle('Add Service Schedule')
            }else{
                setPageTitle('Edit Service Schedule')
            }
        }
        
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/service-requests/list");
                }
            })
        }
    }

    async function submit(e, status = ''){
        e.preventDefault()
        
        let new_form = {
            schedule_date: form_data.schedule_date,
            extra_info: form_data.extra_info,
            members: form_data.members ?? [],
        }
        
        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/${service_request_id}/schedule`)
        const res = await postApiData(endpoint, new_form)

        setLoading(0)
        if(res.status === 'error'){
            if(res.data){
                setErrors( res.data );
            }else{
                setErrors([])
            }
            return
        }

        let id = service_request_id;
        if(!id){
            id = res.data.id
        }

        Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            confirmButtonText: "OK",
        })
        .then((result) => {
            if (result.isConfirmed) {;
                fetchData(id)
            }
        })
    }
    
    function inputChange(e) {
        let { name, value } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;

                if(name == 'warranty_status') value = 'active'
            } else {
                value = 0;

                if(name == 'warranty_status') value = 'expired'
            }
        }
        else if (e.target.type === "file") {
          value = e.target.files[0]
        }

        let new_state = { [name]: value }

        //helpers.updateFormKeys(setFormData, new_state)
        setFormData({ ...form_data, ...new_state });
    }

    function handleCustomer(e){
        console.log(e)
        let data = {...form_data}
        data.customer_id = e.id ?? ''
        data.customer_name = e.contact_name ?? ''
        data.phone_no = e.phone_no ?? ''
        data.email = e.email ?? ''
        setFormData(data)
    }

    function handleProductUnit(e){
        setRecordItems(prevItems => {
            const index = helpers.isObjectExistIndex(prevItems, e.id);

            if (index !== null) {
                const existing = prevItems[index];
                const updatedItem = {
                    ...existing,
                    ...e,
                    complaint: existing.complaint ?? ''
                };
                return helpers.updateItemInState(prevItems, updatedItem);
            }

            const newItem = { ...e, complaint: '' };
            return [...prevItems, newItem];
        });
    }

    function handleSelectedProductUnit(e){
        setRecordItems(prevItems => {
            const index = helpers.isObjectExistIndex(prevItems, e.id);

            if (index !== null) {
                const existing = prevItems[index];
                const updatedItem = {
                    ...existing,
                    ...e,
                    complaint: existing.complaint ?? ''
                };
                return helpers.updateItemInState(prevItems, updatedItem);
            }

            const newItem = { ...e, complaint: '' };
            return [...prevItems, newItem];
        });
    }

    return (
        <div>
            <Layout page_title={page_title} menu="manage-service-requests" breadcrumbs={true} parent_link='/service-requests/list' parent_text="PolarCare">
                    <div className="content">
                        <div className="container-fluid pb-5" style={{position: 'relative'}}>
                            <Loader isLoading={loading}/>
                            <form onSubmit={submit}>
                                <div className="row mb-2">
                                    <div id="so-customer-section" className="col-lg-12">
                                    
                                        {form_data.service_no ?
                                        <div className='border rounded p-3 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-center'>
                                            <h5 className='mb-3 mb-md-0 d-flex'>Service No: {form_data.service_no}
                                                &nbsp;&nbsp;&nbsp;{helpers.displayServiceRequestStatusBadge(form_data.status, form_data.status_name)}
                                            </h5>
                                            <div className='d-flex flex-column flex-sm-row'>
                                            </div>
    
                                            <div className='text-right'>   
                                                {
                                                    parseInt(form_data.status) === 2 || parseInt(form_data.status) === 3 || parseInt(form_data.status) === 4 || parseInt(form_data.status) === 5 ?
                                                    <button type='submit' className='btn btn-success ml-3'>Publish</button> : ''
                                                }
                                                <Link className='btn btn-outline-dark ml-3' to={'/service-requests/list'}>Cancel</Link>
                                            </div>
                                        </div> : ''}

                                        <div className="card">
                                            <div className="card-body pt-md-5">
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>Schedule Date<span className="text-danger">*</span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <div>
                                                        <Calendar 
                                                            name="schedule_date"
                                                            placeholder="Schedule Date"
                                                            value={form_data.schedule_date} 
                                                            onChange={inputChange} 
                                                            className='w-100' 
                                                            dateFormat="yy-mm-dd" 
                                                            icon={() => <i className="far fa-calendar"></i>} 
                                                            showIcon  
                                                            
                                                        />
                                                        </div>
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="schedule_date" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label className='mb-0'>Assigned Technicians<span className="text-danger">*</span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <MultiSelect 
                                                            // value={selectedTechnicians} 
                                                            // onChange={(e) => setSelectedTechnicians(e.value)}
                                                            value={form_data.members} 
                                                            onChange={inputChange}
                                                            options={employee_list} 
                                                            optionLabel="full_name" 
                                                            optionValue="id"
                                                            placeholder="Select Technicians" 
                                                            display="chip"
                                                            filter
                                                            className="w-fulls md:w-20rems"
                                                            name="members"
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="members" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label className='mb-0'>Extra Information</label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <InputTextarea
                                                            id="extra_info" 
                                                            name="extra_info" 
                                                            value={form_data.extra_info ?? ''}  
                                                            className='w-100'
                                                            tagClass="form-control"
                                                            onChange={inputChange}
                                                            placeholder=""
                                                            rows={3}
                                                            
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="extra_info" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='text-right mt-3'>
                                    {
                                        parseInt(form_data.status) === 2 || parseInt(form_data.status) === 3 || parseInt(form_data.status) === 4 || parseInt(form_data.status) === 5 ?
                                        <button type='submit' className='btn btn-success ml-3'>Publish</button> : ''
                                    }
                                    <Link className='btn btn-outline-dark ml-3' to={'/service-requests/list'}>Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
            </Layout>
        </div>
    )
}